import { v4 } from "uuid";

export class ExtraFieldTabConfig {
	ID:string = v4();
	Name:string = "";

	public constructor(data?:any) {
		if (!data) return;
		this.ID = data.ID || v4();
		this.Name = data.Name || "";
	}

	public getJSON() {
		return {
			ID: this.ID,
			Name: this.Name
		};
	}
}
